import { render, staticRenderFns } from "./deleteContractTypeSpec.vue?vue&type=template&id=0214c13e"
import script from "./deleteContractTypeSpec.vue?vue&type=script&lang=js"
export * from "./deleteContractTypeSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports